export const MAX_COMPARE_PRODUCTS = 4

export function normalizeCompareIds(ids: number[]): number[] {
  return [...new Set(ids.filter((id) => Number.isFinite(id) && id > 0))].slice(0, MAX_COMPARE_PRODUCTS)
}

export function parseCompareIds(raw: unknown): number[] {
  if (raw == null || raw === '') return []

  const parts = Array.isArray(raw) ? raw : String(raw).split(',')
  const ids = parts
    .flatMap((part) => String(part).split(','))
    .map((part) => Number(part.trim()))
    .filter((id) => Number.isFinite(id) && id > 0)

  return normalizeCompareIds(ids)
}

export function buildComparePath(ids: number[]): string {
  const normalized = normalizeCompareIds(ids)
  if (!normalized.length) return '/compara'
  return `/compara?ids=${normalized.join(',')}`
}

export function compareIdsEqual(a: number[], b: number[]): boolean {
  return a.length === b.length && a.every((id, index) => id === b[index])
}
